app.controller('BCAAgreementCtrl', ['$scope', '$uibModalInstance', 'agreementNumber', '$q', 'appFactory',
    function ($scope, $uibModalInstance, agreementNumber, $q, appFactory) {

    $scope.agreementNumber = agreementNumber;

    $scope.accept = function () {

        $uibModalInstance.close('accept', $scope.agreementNumber);
    };
    
    $scope.Broker = '';

    var allPromise = $q.all([

        $scope.retrieveSession,

        appFactory.getData(`/service/client.svc/getBrokerClient`).then(function (data) {

            if (data.status == 200) {

                $scope.Broker = data.data.d;
            }
        })
    ]);

    allPromise.then(function () {

    });

    $scope.cancel = function () {

        $uibModalInstance.dismiss('cancel', $scope.agreementNumber);
    };
}]);